export const drawerClosedWidth = 56;
export const drawerWidth = 257;
